import { ImageComponent } from '@apps-common/components/common'
import { VertSpacerLg } from '@apps-common/components/layout'
import { IOrderLineModel } from '@apps-common/types/portal/order'
import { formatPrice } from '@apps-common/utils/helpers'

interface IProps {
  loading: boolean
  orderLine: IOrderLineModel[]
}

export const ManagementOrderDetailsLineItems: React.FC<IProps> = ({ loading, orderLine }) => {
  const total = orderLine?.reduce((acc, curr) => acc + curr.cost, 0) || 0

  return (
    <>
      <VertSpacerLg />
      {loading && (
        <div className='animate-pulse'>
          <div className='px-[15px] py-[15px] bg-skeleton rounded'>
            <div className='h-[25px]' />
          </div>
          <div>
            <div className='p-[10px] py-[15px]'>
              <div className='flex items-center justify-between gap-[5px]'>
                <div className='flex items-center justify-start gap-[10px]'>
                  <div className='h-[40px] w-[40px] bg-skeleton-hi rounded' />
                  <div className='h-[22px] bg-skeleton-hi w-[100px] rounded' />
                </div>
                <div className='flex items-center justify-between gap-[10px]'>
                  <div className='h-[22px] bg-skeleton-hi w-[30px] rounded' />
                  <div className='h-[22px] bg-skeleton-hi w-[30px] rounded' />
                </div>
              </div>
            </div>
          </div>
          <div className='px-[15px] py-[15px] bg-skeleton-hi rounded'>
            <div className='h-[25px]' />
          </div>
        </div>
      )}
      {!loading && (
        <div>
          <div className='jost-light text-[0.8em] sm:text-[0.9em] px-[15px] py-[15px] bg-surface-2 text-text rounded'>
            <div className='flex items-center justify-between gap-[5px]'>
              <p>
                <span className='jost-medium'>Product</span>
              </p>
              <p>
                <span className='jost-medium'>Subtotal</span>
              </p>
            </div>
          </div>
          <div>
            {orderLine &&
              orderLine.map((line: any, index: number) => (
                <div key={`orderline-item-${index}`} className='jost-light text-[0.8em] sm:text-[0.9em] p-[10px] py-[15px]'>
                  <div className='flex items-center justify-between gap-[5px]'>
                    <div className='flex items-center justify-start gap-[10px]'>
                      <ImageComponent
                        src={line.productImageUrl}
                        alt={line.productName}
                        imageClasses='max-w-[40px] max-h-[40px]'
                        errorIconClasses='text-[1.75em] w-[40px] max-h-[40px]'
                      />{' '}
                      <p className='grow flex items-center justify-start gap-[5px]'>
                        {line.productQuantity} x {line.productName}
                      </p>
                    </div>
                    <div className='flex items-center justify-between gap-[10px] text-secondary-content'>
                      {line.discount > 0 && <p className='text-[0.75em] jost-medium'>{line.discount}% discount</p>}
                      <p>{formatPrice(line.cost, 2)}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className='jost-light text-[0.8em] sm:text-[0.9em] p-[10px] py-[15px] bg-surface-2 rounded-b-2xl text-text'>
            <div className='flex items-center justify-end gap-[5px]'>
              <p>
                <span className='jost-medium'>Total</span> {formatPrice(total || 0, 2)}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
